/**
 * Enum for the notification types
 */
export enum NotificationType {
  WARNING = 0,
  ALERT = 1,
  INFO = 2,
  SUCCESS = 3
}
